export const batchActionErrorText = (value, translate) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (value.content) return batchActionErrorText(value.content, translate);
    if (value.vi || value.en) return translate(value);
    if (value.message) return batchActionErrorText(value.message, translate);
    if (value.error) return batchActionErrorText(value.error, translate);
    return '';
};

export function batchActionFailureText(result, requested, translate) {
    const failed = Array.isArray(result?.failedObjs) ? result.failedObjs : [];
    const reasons = [...new Set(failed.map(row => batchActionErrorText(row.error, translate)).filter(Boolean))];
    const topLevel = batchActionErrorText(result?.error || result?.message, translate);
    if (topLevel && !reasons.length) reasons.push(topLevel);
    const count = Number(result?.failed_qty ?? failed.length ?? requested) || requested;
    const prefix = translate({
        vi: `Không xử lý được ${count}/${requested} dòng.`,
        en: `Could not process ${count} of ${requested} rows.`,
        fr: `Échec du traitement de ${count}/${requested} lignes.`,
        es: `No se procesaron ${count} de ${requested} filas.`,
        id: `Gagal memproses ${count}/${requested} baris.`,
        ja: `${count}/${requested}行を処理できませんでした。`,
        zh: `有 ${count}/${requested} 行无法处理。`,
        ko: `${count}/${requested}행을 처리하지 못했습니다.`,
        hi: `${count}/${requested} पंक्तियाँ प्रोसेस नहीं हुईं।`,
        ar: `تعذّرت معالجة ${count}/${requested} صفًا.`
    });
    return reasons.length ? `${prefix} ${reasons.slice(0, 3).join('; ')}` : prefix;
}

export function batchActionFailedRows(rows, result) {
    const failures = Array.isArray(result?.failedObjs) ? result.failedObjs : [];
    const byId = new Map(failures.map(row => [String(row.id), row.error]));
    return rows.filter(row => byId.has(String(row.id))).map(row => ({
        ...row,
        batchAction: { canExecute: false, reason: byId.get(String(row.id)) }
    }));
}
